export default "__VITE_ASSET__ec578c18__"